import StudentGradebookEntry from 'models/StudentGradebookEntry';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppPage } from 'view/components/common/AppPage';
import ModuleView from 'view/components/student/classroom/ModuleView';

const StudentModulePage: React.FC = () => {
  const { moduleId } = useParams();
  const navigate = useNavigate();

  const handleSelectAssignment = (assignment: StudentGradebookEntry) => {
    navigate(`assignments/${assignment.assignment.id}`);
  };

  if (!moduleId) return <AppPage />;

  return (
    <AppPage>
      <ModuleView
        moduleId={moduleId}
        onExit={() => navigate('..')}
        onSelectAssignment={handleSelectAssignment}
      />
    </AppPage>
  );
};

export default StudentModulePage;
